import MuiDivider, {
    DividerProps as MuiDividerProps
} from '@mui/material/Divider';
import * as React from 'react';

import { styled } from '../styled';
import { withVersion } from '../utils';

export interface DividerProps extends MuiDividerProps {
    /** Adds theme spacing above and below horizontal dividers. */
    padding?: boolean;
}

const StyledDivider = styled(MuiDivider)<{ $padding: boolean }>(
    ({ theme, orientation, variant = 'fullWidth', $padding }) => ({
        ...(orientation === 'horizontal' &&
            variant === 'fullWidth' && { width: '100%' }),
        ...($padding &&
            orientation !== 'vertical' && {
                marginTop: theme.spacing(0.75),
                marginBottom: theme.spacing(0.75)
            })
    })
);

const DividerImpl = (props: DividerProps) => {
    const { padding = false, ...muiProps } = props;

    return (
        <StyledDivider data-role="divider" $padding={padding} {...muiProps} />
    );
};

export const Divider = withVersion(DividerImpl, '1.0.0');
